// Accordion component behaviour, relocated from the inline script in accordion.latte.
// Each .component.accordion instance toggles its panels open/closed and mirrors the
// open item's image; the open panel's height is recalculated on resize. Buttons and
// mirror images are matched structurally, so the template no longer needs the random
// per-instance class names the inline script relied on.

function initAccordion(accordion) {
  const acc = Array.from(accordion.querySelectorAll('.overview button'));
  const imgs = Array.from(accordion.querySelectorAll('.images img'));

  if (!acc.length) {
    return;
  }

  let openIndex = 0;

  function openItem(j) {
    acc.forEach((item, i) => {
      const panel = item.nextElementSibling;
      const isTarget = i === j;

      item.classList.toggle('active', isTarget);

      if (isTarget) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        if (imgs[i]) {
          imgs[i].style.display = 'block';
        }
      } else {
        panel.style.maxHeight = null;
        if (imgs[i]) {
          imgs[i].style.display = 'none';
        }
      }
    });
    openIndex = j;
  }

  function recalcOpenHeight() {
    const item = acc[openIndex];
    if (!item) {
      return;
    }

    const panel = item.nextElementSibling;
    if (item.classList.contains('active')) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  acc.forEach((item, j) => {
    item.addEventListener('click', () => {
      if (openIndex === j) {
        item.classList.remove('active');
        item.nextElementSibling.style.maxHeight = null;
        if (imgs[j]) {
          imgs[j].style.display = 'none';
        }
        openIndex = -1;

        return;
      }

      openItem(j);
    });
  });

  openItem(0);

  let resize = null;
  window.addEventListener('resize', () => {
    if (resize) {
      return;
    }

    resize = requestAnimationFrame(() => {
      recalcOpenHeight();
      resize = null;
    });
  }, { passive: true });
}

document.querySelectorAll('.component.accordion').forEach(initAccordion);
